// WHATSAPP-OTP-STANDARD-001 — Code-Schritt der SMS-Zwei-Faktor-Anmeldung im Partner-Portal.
//
// Backend-Vertrag (backend/src/routes/auth.js, POST /auth/login):
//   • 401 { error:'sms_2fa_required', sms:true, phone, message, retry_after_seconds[, channel] }
//     → Code liegt per SMS bzw. (nur mit Capability-Token) per WhatsApp vor.
//   • 401 { error:'sms_2fa_required', sms:false, channel:'email', email, message, retry_after_seconds }
//     → Ersatzkanal E-Mail (ZWEI-FAKTOR-ERSATZKANAL-001; gilt auch ohne Token).
//   • Code absenden = dieselbe /login-Anfrage mit `sms_code` (der Server prüft SMS- UND E-Mail-Code).
//   • 401 sms_2fa_invalid = Code falsch/abgelaufen; 503 sms_2fa_delivery_failed = kein Weg zustellbar;
//     503 sms_delivery_failed = „Lieber per SMS" ging gerade nicht raus.
import { otpChannelOf, otpSentText, errorAdvertisedOtp } from './otpChannel';

export const TWO_FACTOR_TEXT = Object.freeze({
  title: 'Anmeldecode eingeben',
  sentViaEmail: 'Wir haben dir den Code per E-Mail geschickt.',
  sentFallback: 'Wir haben dir einen Code per SMS geschickt.',
  submit: 'Bestätigen und anmelden',
  submitting: 'Wird geprüft …',
  resend: 'Code erneut senden',
  back: 'Zurück zur Anmeldung',
  invalid: 'Code ungültig oder abgelaufen.',
  turnstile: 'Bitte bestätige die Bot-Prüfung erneut, um fortzufahren.',
});

// Antwort → Zustand des Code-Schritts; null, wenn die Antwort KEIN Code-Schritt ist.
export function twoFactorFromError(error, now = Date.now()) {
  const data = error?.response?.data;
  if (error?.response?.status !== 401 || data?.error !== 'sms_2fa_required') return null;
  const email = data.channel === 'email';
  const channel = email ? 'email' : otpChannelOf(data, errorAdvertisedOtp(error));
  const wait = Number(data.retry_after_seconds);
  return Object.freeze({
    channel,   // 'whatsapp' | 'sms' | 'email' | null (= Server-Text wie bisher)
    target: typeof (email ? data.email : data.phone) === 'string' ? (email ? data.email : data.phone) : null,
    message: typeof data.message === 'string' && data.message.trim() ? data.message : null,
    resendAt: now + (Number.isFinite(wait) && wait > 0 ? Math.min(wait, 600) : 0) * 1000,
  });
}

export function twoFactorHint(state) {
  if (!state) return null;
  if (state.channel === 'email') return TWO_FACTOR_TEXT.sentViaEmail;
  return otpSentText(state.channel, state.message || TWO_FACTOR_TEXT.sentFallback);
}

// Zusatzfeld für „Code erneut senden": im E-Mail-Ersatzkanal bleibt es bei der E-Mail.
export const resendExtra = (state) => (state?.channel === 'email' ? { two_factor_channel: 'email' } : null);
